var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#shopping-cart_svg__clip0_27100_239364)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#007F33"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.458 14.875a1.417 1.417 0 112.834 0 1.417 1.417 0 01-2.833 0zM13.25 14.875a1.417 1.417 0 112.833 0 1.417 1.417 0 01-2.833 0zM.5.708C.5.318.817 0 1.208 0h2.834c.337 0 .628.238.694.57l.595 2.972h11.46a.708.708 0 01.697.84l-1.135 5.949a2.124 2.124 0 01-2.118 1.71H7.364a2.125 2.125 0 01-2.118-1.71L4.062 4.42a.706.706 0 01-.012-.06l-.589-2.942H1.208A.708.708 0 01.5.708zm5.115 4.25l1.02 5.097a.708.708 0 00.708.57h6.912a.708.708 0 00.708-.568l.973-5.099H5.614z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shopping-cart_svg__clip0_27100_239364"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h17v17H0z"
  })))));
}
export default SvgShoppingCart;